<template>
  <div class="widget">
    <template>
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" class="nav-item" :class="{ active: activeName == 'ActionTracker' }">
          <span class="nav-link" role="tab" @click="setTab('ActionTracker')" data-toggle="tab">
            <img class="dashboard-icons" src="/static/images/icons/submission_icon_blue.svg" />
            Activity Tracker
          </span>
        </li>
        <li role="presentation" class="nav-item" :class="{ active: activeName == 'DueDates' }">
          <span class="nav-link" role="tab" @click="setTab('DueDates')" data-toggle="tab">
            <img class="dashboard-icons" src="/static/images/icons/sb_due_date.svg" />
            Due Dates
          </span>
        </li>
      </ul>
    </template>
    <div class="dashboard-widget-bodies">
      <div v-show="selectedMenu === 'ActionTracker'">
        <div
          class="dashboard-widget-body"
          data-tab="tracker"
          data-widget="2"
          v-for="(items, index) in activityData"
          :key="index"
        >
          <h3>{{ index | capitalize }}</h3>
          <div v-if="items.length == 0 && index == 'today'">
            <div class="empty-data">There has been no activity today.</div>
          </div>
          <div v-if="items.length == 0 && index == 'yesterday'">
            <div class="empty-data">There has been no activity yesterday.</div>
          </div>
          <div class="row dashboard-widget-due-date" v-for="item in items" :key="item.projectId">
            <div class="col-xs-11">
              <div class="display-inline" v-if="item.type === 'ADDED_COMMENT'">
                <div class="widget-icon">
                  <i class="fa fa-comment-o"></i>
                  <span class="badge">{{ item.count }}</span>
                </div>
                <a class="cursor-pointer" @click="redirect(item.nextUrl)"
                  >{{ item.title }} has new comments</a
                >
              </div>
              <div class="display-inline" v-if="item.type === 'EXPORT_QUEUED'">
                <div class="widget-icon">
                  <img src="/static/images/icons/export.svg" class="calender-icon" />
                </div>
                <a class="cursor-pointer" @click="redirect(item.nextUrl)"
                  >{{ item.title }} has been exported</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selectedMenu === 'DueDates'">
        <div
          class="dashboard-widget-body"
          data-tab="tracker"
          data-widget="2"
          v-for="(items, index) in dueData"
          :key="index"
        >
          <h3>{{ index | capitalize }}</h3>
          <div v-if="items.length == 0 && index == 'today'">
            <div class="empty-data">There are no nodes due today.</div>
          </div>
          <div v-if="items.length == 0 && index == 'soon'">
            <div class="empty-data">There are no nodes due within the next 60 days.</div>
          </div>
          <div class="row dashboard-widget-due-date" v-for="item in items" :key="item.id">
            <div class="col-xs-11 display-inline">
              <div class="widget-icon">
                <img src="/static/images/icons/calender_icon.svg" class="calender-icon" />
              </div>
              <a class="cursor-pointer" @click="redirect(item.nextUrl)"
                >{{ item.title }} is due {{ item.due }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['sbData'],
  data() {
    return {
      activeName: 'ActionTracker',
      selectedMenu: 'ActionTracker',
      activityData: {},
      dueData: {}
    };
  },
  created() {
    this.accessData();
  },
  methods: {
    setTab(tab) {
      this.activeName = tab;
      this.selectedMenu = this.activeName;
    },
    async accessData() {
      const x = this.sbData;
      this.activityData = x.actions;
      this.dueData = x.dueDates;
    },
    redirect(url) {
      this.$router.push(`/layout/submission-builder?nextUrl=${url}`);
    }
  },
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style scoped>
ul.nav-tabs > li {
  margin-right: 40px;
  padding-bottom: 14px;
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
}
.widget .active {
  color: #0b3c61;
}
@media only screen and (max-width: 767px) {
  ul.nav-tabs > li {
    margin-right: 18px;
    padding-bottom: 14px;
  }
}
.exact-date {
  text-align: end;
}
.empty-data {
  padding-bottom: 15px;
}
.activity-export-icon {
  margin-right: 20px;
}
.dashboard-widget-body .dashboard-widget-due-date a {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 17px;
  padding-right: 5px;
}
.dashboard-widget-body h3 {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
}
.dashboard-widget-body h3.mt-15 {
  margin-top: 15px;
}
.dashboard-widget-body .dashboard-widget-due-date {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  margin-top: 0px;
  margin-bottom: 5px;
}
.smart-builder-tabs {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  padding: 12px;
}
.pl-0 {
  padding-left: 0px;
}
.comments-notification {
  position: absolute;
  margin-top: -6px;
  margin-left: 14px;
}
.pl-5 {
  padding-left: 5px;
}
.d-flex {
  display: flex;
}
.status-expiry {
  position: absolute;
  margin-left: 16px;
  margin-top: -9px;
}
.widget-icon {
  margin-top: -2px;
}
.comment-count-wrapper {
  position: relative;
  margin-right: 10px;
  min-width: 34px;
}
.badge {
  background-color: #b00505;
  color: #fff;
  position: absolute;
  top: -5px;
  left: 25px;
}
.dashboard-widget-bodies {
  max-height: 190px;
  overflow-y: auto;
  scrollbar-width: thin;
  overflow-x: hidden;
}
.fa-comment-o {
  font-size: 24px;
}
.widget-icon img {
  width: 24px;
  height: 24px;
  vertical-align: top;
}
.pl-25 {
  padding-left: 25px;
}
.display-inline {
  display: inline-flex;
}
/* tab CSS */
.reg-update-tabs {
  margin-left: 24px;
  width: calc(100% - 50px);
}
.horizontal-tabs li {
  list-style: none;
  white-space: nowrap;
  margin-right: 32px;
  font-family: 'Roboto';
  font-style: normal;
  height: 42px;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #000000;
}
.horizontal-tabs::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.horizontal-tabs {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
}
.horizontal-tabs li.active {
  color: #0b3c61;
  border-bottom: 8px solid #4c9e45;
  font-weight: bold;
}
.horizontal-tabs {
  width: 100%;
  position: relative;
  overflow-x: auto;
  border-bottom: 1px solid #bdbdbd;
  margin-top: 18px;
  margin-bottom: 14px;
}
@media (max-width: 1200px) {
  .horizontal-tabs {
    margin-top: 17px;
  }
}
</style>
